import { Layout } from "antd";
import { LanguageSwitcherButton } from "features/language-switcher";

const headerStyle: React.CSSProperties = {
  height: 64,
  paddingInline: 16,
  paddingTop: "calc(var(--safe-area-inset-top, env(safe-area-inset-top, 0px)))",
  textAlign: "end",
  backgroundColor: "transparent",
};

export const AuthHeader = () => {
  return (
    <Layout.Header style={headerStyle}>
      <LanguageSwitcherButton />
    </Layout.Header>
  );
};
